import React from 'react';
import './Skills.css';
import html from '../../images/html5.png';
import css from '../../images/css3.png';
import bootstrap from '../../images/bootstrap.png';
import js from '../../images/javascript.png';
import react from '../../images/react.png';
import firebase from '../../images/firebase.png';
import node from '../../images/node-js.png';
import mongoDb from '../../images/mongodb.png';
import express from '../../images/express.png';
import redux from '../../images/redux.png';
import Zoom from 'react-reveal/Zoom';
 

const Skills = () => {
    return (
        <div className='skills_section'>
            <Zoom cascade duration={1500}>
                <div className='skill__title' >
                    <p className='skill__main_title'>Skills & Tools</p>
                    <h1>My Toolbox & Some Things I Can Do</h1>
                    <p>The skills, tools and technology I use to bring your products to life</p>
                </div>
            </Zoom>
            <div className='skills__images'>
                <div className='images'>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={html} alt="" />
                            <p>HTML5</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={css} alt="" />
                            <p>CSS3</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={bootstrap} alt="" />
                            <p>Bootstrap5</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={js} alt="" />
                            <p>JavaScript</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={react} alt="" />
                            <p>React</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={firebase} alt="" />
                            <p>Firebase</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={node} alt="" />
                            <p>Nose JS</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={express} alt="" />
                            <p>Express JS</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={mongoDb} alt="" />
                            <p>MongoDb</p>
                        </div>
                    </Zoom>
                    <Zoom duration={2000}>
                        <div className='image' >
                            <img src={redux} alt="" />
                            <p>Redux</p>
                        </div>
                    </Zoom>
                </div>
            </div>
        </div>
    );
};

export default Skills;